export const getDomainHash = async (domain) => {
    const digest = await crypto.subtle.digest(
        "SHA-256",
        new TextEncoder().encode(domain)
    )

    return btoa(
        String.fromCharCode(...new Uint8Array(digest).slice(0, 16))
    )
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=+$/, "")
}

export const login = async (hash) => {
    return fetch(`${process.env.REACT_APP_OUTBACK_API_URL}/${process.env.REACT_APP_STAGE}/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "OutbackHash": hash },
    })
}